export const GET_STUDENTS = "GET_STUDENTS";

export const SET_STUDENTS = "SET_STUDENTS";


export const EMAIL_EXISTS = "EMAIL_EXISTS";